export default "__VITE_ASSET__LWrn7D5c__"